import React from "react";
import styles from "./InfoStrip.module.css";

/**
 * The green summary pill under a section's fields, as the design draws it:
 * "Type: Flex | Batch ID: … | Class frequency: …". It is as wide as its content,
 * facts are separated by a grey bar, and a fact with no value is left out rather
 * than rendered as "—", so the strip only ever says what is known.
 *
 * @param {{ lead?: React.ReactNode,
 *           items: {key: string, label: string, value: React.ReactNode}[] }} props
 */
const InfoStrip = ({ lead = null, items }) => {
  const shown = items?.filter((item) => item?.value !== null && item?.value !== undefined && item?.value !== "");
  if (!lead && !shown?.length) return null;

  return (
    <div className={styles.strip}>
      {lead && <span className={styles.lead}>{lead}</span>}
      {shown?.length > 0 && (
        <span className={styles.items}>
          {shown?.map((item, index) => (
            <React.Fragment key={item?.key}>
              {index > 0 && (
                <span className={styles.separator} aria-hidden="true">
                  {" | "}
                </span>
              )}
              <span className={styles.item}>
                {/* The space is invisible in the flex row (the gap spaces it) but keeps
                    the text reading "Label: value" when copied or read aloud. */}
                <span className={styles.label}>{item?.label}:</span>{" "}
                <strong className={styles.value}>{item?.value}</strong>
              </span>
            </React.Fragment>
          ))}
        </span>
      )}
    </div>
  );
};

export default InfoStrip;
